// extracted by mini-css-extract-plugin
export var uploadFileBlockContent = "upload-file-block__content_iVQTYfltuReMONkQYNp4";
export var uploadFileBlockDropzone = "upload-file-block__dropzone_UHcieqrlLbqXG1S0dpZM";
export var uploadFileBlockDropzoneNonActive = "upload-file-block__dropzone_non-active_KDtgViSuG8SkEQiavUMc";
export var uploadFileBlockEmailCell = "upload-file-block__email-cell_Oab6HW6_1RED7l2aLAip";
export var uploadFileBlockHeader = "upload-file-block__header_E9cMOzADHAFVtcv76gFA";
export var uploadFileBlockIdCell = "upload-file-block__id-cell_vRNFzfsxJ2jWYvQNbhWH";
export var uploadFileBlockList = "upload-file-block__list_f1S08Q5fZ12n2zCEzTC3";
export var uploadFileBlockReviewPartition = "upload-file-block__review-partition_uLOL3dyt_Hugz9z9fWMf";
export var uploadFileBlockUploadPartition = "upload-file-block__upload-partition_bGJVLsnGGhb53L1XACJs";